export const permissionsList = {
  Galeria: 'mediaPermission',
  Postagens: 'postPermission',
  Avaliações: 'reviewsPermission',
  Serviços: 'servicePermission',
};
